export default $ => {
        
    // Initialize blueimp container
    $('<div id="blueimp-gallery" class="blueimp-gallery blueimp-gallery-controls">')
            .append('<div class="slides">')
            .append('<h3 class="title">')
            .append('<a class="play-pause">')
            .append('<ol class="indicator">')
            .append($('<a class="prev">').text('‹'))
            .append($('<a class="next">').text('›'))
            .append($('<a class="close">').text('×'))
            .appendTo($('body'))
    ;

    // Handle gallery
    $('[data-gallery]').on('click', function (e) {
        e.preventDefault();
        const galleryName = $(this).data('gallery');
        
        if (!galleryName) {
            console.error(this, 'No gallery name provided');
            return;
        }
        
        blueimp.Gallery($(`[data-gallery="${galleryName}"]`), {
            index: this
        });
    });
}



// WEBPACK FOOTER //
// ./assets/js/component/gallery.js